import { render, staticRenderFns } from "./TheCover.vue?vue&type=template&id=d95d18a8&"
import script from "./TheCover.vue?vue&type=script&lang=js&"
export * from "./TheCover.vue?vue&type=script&lang=js&"
import style0 from "./TheCover.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports